import React from "react";
import * as Icons from "lucide-react";
import useReveal from "../hooks/useReveal";
import { industries } from "../mock";

const Industries = () => {
  const [ref, inView] = useReveal();

  return (
    <section id="industries" className="py-20 md:py-28 bg-white">
      <div ref={ref} className="pp-container">
        <div className={`text-center pp-reveal ${inView ? "pp-in" : ""}`}>
          <span className="inline-flex items-center gap-2 text-[#06B6D4] font-semibold uppercase tracking-wider text-sm">
            <span className="w-8 h-[2px] bg-[#06B6D4]" /> Industries
          </span>
          <h2 className="mt-4 text-3xl md:text-5xl font-extrabold text-[#0D1B2A]">
            Industries <span className="pp-grad-text">We Serve</span>
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
          {industries.map((ind, i) => {
            const Icon = Icons[ind.icon] || Icons.Building2;
            return (
              <div
                key={ind.label}
                className={`group rounded-2xl border border-slate-100 bg-[#f6f9fd] p-8 text-center pp-lift pp-reveal ${inView ? "pp-in" : ""}`}
                style={{ animationDelay: `${i * 0.06}s` }}
              >
                <div className="w-16 h-16 mx-auto rounded-2xl bg-white flex items-center justify-center shadow-sm group-hover:bg-[#0D1B2A] transition-colors">
                  <Icon size={28} className="text-[#0EA5E9] group-hover:text-[#10B981] transition-colors" />
                </div>
                <div className="mt-4 font-semibold text-[#0D1B2A] text-[15px]">{ind.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
